import { render, staticRenderFns } from "./addSow.vue?vue&type=template&id=425a0ce4&"
import script from "./addSow.vue?vue&type=script&lang=js&"
export * from "./addSow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports